import React from 'react';

const Testimonials = () => {
  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">Why Choose Travora?</h2>

      <div className="row text-center">

        <div className="col-md-4 mb-4">
          <div className="p-4 border rounded h-100">
            <h1>💳</h1>
            <h5>Secure Advance Payment</h5>
            <p className="text-muted">
              Book your trips with safe and secure advance payment options.
            </p>
          </div>
        </div>

        <div className="col-md-4 mb-4">
          <div className="p-4 border rounded h-100">
            <h1>🔁</h1>
            <h5>Easy Refund Policy</h5>
            <p className="text-muted">
              Hassle-free refund management for cancelled or rescheduled trips.
            </p>
          </div>
        </div>

        <div className="col-md-4 mb-4">
          <div className="p-4 border rounded h-100">
            <h1>📍</h1>
            <h5>Trusted Local Organizers</h5>
            <p className="text-muted">
              We work with verified tour operators across Mysore.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Testimonials;
















